import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_78_126)">
        <path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM4.25639 5.67208C2.8461 7.39583 2 9.5991 2 12C2 17.5228 6.47715 22 12 22C14.4009 22 16.6042 21.1539 18.3279 19.7436L4.25639 5.67208ZM12 2C9.5991 2 7.39583 2.8461 5.67208 4.25639L19.7436 18.3279C21.1539 16.6042 22 14.4009 22 12C22 6.47715 17.5228 2 12 2ZM8.171 11L11.172 14H5.2546C4.84165 14 4.67454 13.9536 4.51158 13.8664C4.34861 13.7793 4.22072 13.6514 4.13357 13.4884C4.04641 13.3255 4 13.1583 4 12.7454V12.2546C4 11.8417 4.04641 11.6745 4.13357 11.5116C4.22072 11.3486 4.34861 11.2207 4.51158 11.1336C4.67454 11.0464 4.84165 11 5.2546 11H8.171ZM18 11C18.5523 11 19 11.4477 19 12V13C19 13.5523 18.5523 14 18 14H17V11H18ZM16.5 11V13.672L13.828 11H16.5ZM16.5 6.5C16.7455 6.5 16.9496 6.6415 16.9919 6.8281L17 6.9V7.7C17 7.87518 17.049 7.96236 17.2552 8.13663L17.3536 8.21716C17.7679 8.54865 17.96 8.78272 17.9943 9.16628L18 9.3V10.1C18 10.3209 17.7761 10.5 17.5 10.5C17.2545 10.5 17.0504 10.3585 17.0081 10.1719L17 10.1V9.3C17 9.12482 16.951 9.03764 16.7448 8.86337L16.6464 8.78284C16.2321 8.45135 16.04 8.21728 16.0057 7.83372L16 7.7V6.9C16 6.67909 16.2239 6.5 16.5 6.5ZM18 6C18.2455 6 18.4496 6.1415 18.4919 6.3281L18.5 6.4V7.2C18.5 7.37518 18.549 7.46236 18.7552 7.63663L18.8536 7.71716C19.2679 8.04865 19.46 8.28272 19.4943 8.66628L19.5 8.8V9.6C19.5 9.82091 19.2761 10 19 10C18.7545 10 18.5504 9.8585 18.5081 9.6719L18.5 9.6V8.8C18.5 8.62482 18.451 8.53764 18.2448 8.36337L18.1464 8.28284C17.7321 7.95135 17.54 7.71728 17.5057 7.33372L17.5 7.2V6.4C17.5 6.17909 17.7239 6 18 6Z" />
      </g>
      <defs>
        <clipPath id="clip0_78_126">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
